// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { serverOnly$ } from 'vite-env-only/macros';
import { initLogger, type LogLevel, type Logger } from '@huuvaos/logger';
import { initLogger as initExpressLogger } from '@huuvaos/express-logger';
import { config } from 'util-config';

const browserLogger: Logger = initLogger({
  format: config.LOG_FORMAT as 'text' | 'json',
  level: config.LOG_LEVEL as LogLevel,
  browser: {
    asObject: true,
    serialize: true,
  },
});

const serverLogger = serverOnly$(() =>
  initExpressLogger({
    format: config.LOG_FORMAT as 'text' | 'json',
    level: config.LOG_LEVEL as LogLevel,
  }),
);

export const logger: Logger = serverLogger ? serverLogger() : browserLogger;
